import { Controller } from '@hotwired/stimulus';

import { repeated } from '@/modules/mask';

export default class extends Controller {
  connect() {
    const { maxlength, minlength } = this.element.attributes;
    const max = Number(maxlength?.value || 5);
    const min = Number(minlength?.value || 1);

    repeated(this.element, { lazy: true }, '0', min, max);
  }
}
